module.exports = __webpack_public_path__ + "8f1eb53e8c02accbbb503ea5af78bdad.jpg";